import {hasLocalStorageFlag} from './localStorageFlags';

export const ANDROID_APP_REVIEW_CAPABILITY_LOCAL_STORAGE_KEY = 'android_app_review_capability';

interface AndroidBridge {
  requestReview?: () => void;
  sharePdf?: (base64: string, fileName: string, title: string) => void;
}

const getAndroidBridge = (): AndroidBridge | undefined => (window as any).Android;

export const requestAndroidAppReview = () => {
  const androidBridge = getAndroidBridge();

  if (androidBridge && typeof androidBridge.requestReview === 'function') {
    androidBridge.requestReview()
  } else if (hasLocalStorageFlag(ANDROID_APP_REVIEW_CAPABILITY_LOCAL_STORAGE_KEY)) {
    console.info('Android app review requested via localStorage fallback');
  }
}

export const hasAndroidAppReviewCapability = (): boolean => {
  const androidBridge = getAndroidBridge();

  return androidBridge && typeof androidBridge.requestReview === 'function' ||
    hasLocalStorageFlag(ANDROID_APP_REVIEW_CAPABILITY_LOCAL_STORAGE_KEY);
}

export const hasAndroidPdfShareCapability = (): boolean => {
  const androidBridge = getAndroidBridge();

  return !!androidBridge && typeof androidBridge.sharePdf === 'function';
}

const blobToBase64 = (blob: Blob): Promise<string> => new Promise((resolve, reject) => {
  const reader = new FileReader();

  reader.onload = () => {
    const result = reader.result;
    if (typeof result !== 'string') {
      reject(new Error('Unable to encode PDF'));
      return;
    }

    resolve(result.substring(result.indexOf(',') + 1));
  };
  reader.onerror = () => reject(reader.error || new Error('Unable to read PDF'));
  reader.readAsDataURL(blob);
});

export const sharePdfWithAndroidApp = async (
  blob: Blob,
  fileName: string,
  title: string,
): Promise<boolean> => {
  const androidBridge = getAndroidBridge();
  if (!androidBridge || typeof androidBridge.sharePdf !== 'function') {
    return false;
  }

  const base64 = await blobToBase64(blob);
  androidBridge.sharePdf(base64, fileName, title);
  return true;
}
